import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";

import {
  removePost,
  accusePost,
  popularPost,
  loadDetailPost,
} from "redux/modules/postSlice";
import { DeleteModal, ConfirmMsg, Accused } from "../MoreComponent";

import { DetailLine } from "../common/commonStyle";
import {
  HeadContainer,
  ArrowBack,
  MoreVert,
  MoreContainer,
} from "./DetailHeaderStyle";

function DetailHeader({ post }) {
  const [modalToggle, setModalToggle] = useState(false); // 더보기-삭제누를시 나오는토글
  const [deleteMsgToggle, setDeleteMsgToggle] = useState(false); //삭제됨알림
  const [accusedToggle, setAccusedToggle] = useState(""); // 왜 props로 보내려고했을까,,
  const accusePosts = useSelector((state) => state.post.accusePosts);

  // 게시글/댓글/답글 신고 여부는 백엔드에서 넣어주면 아래주석 삭제후 그걸로 처리
  // const isAccused = accusePosts.find(
  //   (accusePost) => accusePost.boardId === post.boardId,
  // );

  // 신고됨 알림
  useEffect(() => {
    // 게시글/댓글/답글 신고 여부는 백엔드에서 넣어주면 아래 조건 그데이터로 넣기
    // isAccused && <Accused dispatchName={accusePost} />;
    // accusedToggle && <Accused />;
    const accuseTimeout = setTimeout(() => {
      setAccusedToggle("");
    }, 700);
    return clearTimeout(accuseTimeout);
  }, [accusedToggle]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [more, setMore] = useState(false); // 더보기버튼

  // 1: 일반유저, 0: 관리자
  const isLevel = window.localStorage.getItem("level");

  const myNickName = window.localStorage.getItem("nickname");
  const postAuthor = post.nickname;
  const isMe = myNickName === postAuthor;

  // 더보기 토글 - 수정,삭제 / 신고
  const onClickMore = useCallback(() => {
    setMore((prev) => !prev);

    console.log(isLevel);
  }, [isLevel]);

  // 삭제 - props전달할것들
  const query = "게시글을 삭제하시겠습니까?";
  const notice = "삭제한 게시글은 복구할 수 없습니다.";
  const afterConfirm = "게시글이 삭제되었습니다";
  const onClickCancel = () => {
    setModalToggle(false);
  };
  const onClickConfirm = () => {
    setModalToggle(false);
    setDeleteMsgToggle(true);

    dispatch(removePost(post.boardId));

    setTimeout(() => {
      setDeleteMsgToggle(false);
      navigate("/boards");
    }, 700);
  };

  //삭제버튼 클릭시
  const onClickRemove = useCallback((e) => {
    // e.stopPropagation();
    setModalToggle(true);
    setMore(false);
  }, []);

  // 관리자- 인기게시글 지정/취소
  const onClickPopular = useCallback(() => {
    dispatch(popularPost(post.boardId))
      .unwrap()
      .then(() => {
        dispatch(loadDetailPost(post.boardId));
      });
  }, [dispatch, post.boardId]);

  return (
    <>
      <HeadContainer>
        <ArrowBack
          src="/img/arrowBack.svg"
          alt="arrow back"
          onClick={() => navigate(-1)}
        />
        <MoreVert
          src="/img/moreVert.svg"
          alt="arrow back"
          onClick={onClickMore}
        />
      </HeadContainer>
      <DetailLine />
      {more && (
        <MoreContainer>
          {isLevel === "0" ? ( // 관리자여부
            <div>
              {post.isBest === 1 ? (
                <div onClick={onClickPopular}>인기 게시글 지정 취소</div>
              ) : (
                <div onClick={onClickPopular}>인기 게시글 지정</div>
              )}
              <div onClick={onClickRemove}>삭제</div>
            </div>
          ) : isMe === true ? ( // 작성자 본인여부
            <div>
              <div>
                <Link to={`/boards/update/${post.boardId}`}>수정</Link>
              </div>

              <div onClick={onClickRemove}>삭제</div>
            </div>
          ) : (
            <div>
              <Link to={`/boards/${post.boardId}/report`}>
                <div>게시글 신고</div>
              </Link>
            </div>
          )}
        </MoreContainer>
      )}
      {/* 삭제관련 토글 */}
      {modalToggle && (
        <DeleteModal
          query={query}
          notice={notice}
          onClickCancel={onClickCancel}
          onClickConfirm={onClickConfirm}
        />
      )}
      {/* 삭제됨 알림 */}
      {deleteMsgToggle && <ConfirmMsg afterConfirm={afterConfirm} />}
      {/* 신고됨 알림 */}
      {accusedToggle && <Accused />}
    </>
  );
}

export default DetailHeader;
